import {alertController, modalController} from '@ionic/vue';
import ItemSearchModal from "@/components/Modals/ItemSearchModal";

import axios from 'axios';

class ItemSearchModalHelper {
    /**
     * present an alert dialog, ask for an input id, fetch the
     * corresponding data from the remote service, and return
     * that item.
     *
     * @returns {Promise<any>}
     */
    async capacitorUi(include = '') {
        const alert = await alertController.create({
            header: 'Enter Item #ID',
            inputs: [{
                type: 'number',
                name: 'item_id'
            }],
            buttons: ['Ok']
        });
        await alert.present();
        return alert.onDidDismiss().then(response => {
            return axios.get(`/api/items/${response.data.values.item_id}`, {
                params: {include: include}
            });
        });
    }

    /**
     * We now support a configurable include to send down to the
     * search component. That include will be passed into the search
     * query...
     *
     * @param include
     * @returns {Promise<OverlayEventDetail<any>>}
     */
    open(include = null) {

        const props = {
            title: 'Item Search'
        };

        if (include) {
            props.include = include;
        }

        return modalController.create({
            component: ItemSearchModal,
            componentProps: props
        }).then(modal => {
            modal.present();
            return modal.onDidDismiss();
        });
    }
}
export default new ItemSearchModalHelper();
